import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Home.css";
import teaching from "./assets/students2.png";
import journal from "./assets/attendance.png";
import profile from "./assets/shortlist.png";
import salary from "./assets/salary-voucher.png";
import survey from "./assets/survey.png";
import sunrise from "./assets/sunrise.png";
import sunset from "./assets/sunset.png";
import def from "./assets/default.png";
import afternoon from "./assets/afternoon.png";
import { hitApi } from "../utils/apiCall";

const Home = () => {
  const [fetchedSession, setFetchedSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState(
    localStorage.getItem("session") || ""
  );
  const [errorMsg, setErrorMsg] = useState("");

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) return ["Morning", sunrise];
    if (currentHour < 15) return ["Afternoon", afternoon];
    return ["Evening", sunset];
  };

  useEffect(() => {
    async function fetchSessions() {
      const fd = new FormData();
      const res = await hitApi(
        "settings/sessionSettingsCurl",
        "getSessionDetailsForSelect",
        fd
      );
      if (res.success) {
        setFetchedSession(res.data);
      } else {
        setFetchedSession([]);
      }
    }
    fetchSessions();
  }, []);

  const handleProtectedClick = (e, path) => {
    if (!selectedSession) {
      e.preventDefault();
      setErrorMsg("Please Select Session");
    }
  };

  return (
    <div>
      <div className="page-content-wrapper py-3">
        {/* Header */}
        <div className="container p-3" style={{ marginTop: "18px" }}>
          <div className="card rounded-4 user-info-card mt-2 py-3 px-2">
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <img
                  className="rounded-circle"
                  width={90}
                  src={def}
                  alt="User Profile"
                />
                <div className="user-info ms-3">
                  <h6 className="mb-1 fz-12">{`Good ${getGreeting()[0]},`}</h6>
                  <h6 className="mb-1">
                    {localStorage.getItem("user-name")}
                  </h6>
                </div>
              </div>
              <img width={50} src={getGreeting()[1]} alt="Greeting Icon" />
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="container" style={{ marginBottom: "5rem" }}>
          <div className="row">
            {/* Session Dropdown */}
            <div className="col-12 mb-2">
              <select
                name="session"
                value={selectedSession}
                onChange={(e) => {
                  const val = e.target.value;
                  setSelectedSession(val);
                  localStorage.setItem("session", val);
                  setErrorMsg("");
                }}
                className="form-select form-select-lg"
              >
                <option value="">Select Session</option>
                {fetchedSession.map((ele) => (
                  <option key={ele.id} value={ele.id}>
                    {ele.school_year}
                  </option>
                ))}
              </select>
              {errorMsg && (
                <small className="text-danger m-1 d-block">
                  {errorMsg}
                </small>
              )}
            </div>

            {/* Student Attendance */}
            <div className="col-6 mb-2">
              <Link
                to="/attendance-form"
                onClick={(e) => handleProtectedClick(e, "/attendance-form")}
                className="card card-hover rounded-4 shadow-sm"
              >
                <div className="card-body text-center">
                  <img className="mb-2" src={journal} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Student Attendance</h2>
                </div>
              </Link>
            </div>

            {/* Staff Attendance */}
            <div className="col-6 mb-2">
              <Link
                to="/teacher-attendance-form"
                onClick={(e) => handleProtectedClick(e, "/teacher-attendance-form")}
                className="card card-hover rounded-4 shadow-sm"
              >
                <div className="card-body text-center">
                  <img className="mb-2" src={journal} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Staff Attendance</h2>
                </div>
              </Link>
            </div>

            {/* Other tiles remain unchanged (example below) */}
            <div className="col-6 mb-2">
              <Link
                to="/student-details"
                className="card card-hover rounded-4 shadow-sm"
              >
                <div className="card-body text-center">
                  <img className="mb-2" src={teaching} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Students</h2>
                </div>
              </Link>
            </div>

            <div className="col-6 mb-2">
              <Link to="/profile" className="card card-hover rounded-4 shadow-sm">
                <div className="card-body text-center">
                  <img className="mb-2" src={profile} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Profile</h2>
                </div>
              </Link>
            </div>

            <div className="col-6 mb-2">
              <Link to="/attendance-report" className="card card-hover rounded-4 shadow-sm">
                <div className="card-body text-center">
                  <img className="mb-2" src={salary} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Attendance Report</h2>
                </div>
              </Link>
            </div>
{/* 
            <div className="col-6 mb-2">
              <Link
                to="/question-bank"
                className="card card-hover rounded-4 shadow-sm"
              >
                <div className="card-body text-center">
                  <img className="mb-2" src={survey} width="50" alt="" />
                  <h2 style={{ fontSize: "15px" }}>Question Bank</h2>
                </div>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
